import React, { useState, useEffect } from 'react';
import { Toast } from '../../../components/common/Toast';
import SectionCard from '../../../components/common/SectionCard';
import ToggleField from '../../../components/common/ToggleField';
import { AdditionalSettingsIcon, DangerIcon } from '../../../components/common/SvgIcon';


const save = `${LEGAL_PAGES.assets_url}/images/icons/save.png`;

const Miscellaneous = ({ isLoading, setIsLoading }) => {
  const [saving, setSaving] = useState(false);
  const [formData, setFormData] = useState({
    hide_lp_in_search: false,
    delete_adl_lp_data: false,
  });

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${LEGAL_PAGES.apiUrl}/miscellaneous-settings`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'X-WP-Nonce': LEGAL_PAGES.nonce,
        },
      });

      const result = await response.json();

      if (result.success && result.data) {
        setFormData(result.data);
      }
    } catch (error) {
      console.error('Error fetching miscellaneous settings:', error);
      Toast.error('Failed to load miscellaneous settings');
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      const response = await fetch(`${LEGAL_PAGES.apiUrl}/miscellaneous-settings`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-WP-Nonce': LEGAL_PAGES.nonce,
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (result.success) {
        Toast.success('Miscellaneous settings saved successfully!');
        if (result.data) {
          setFormData(result.data);
        }
      } else {
        Toast.error('Failed to save miscellaneous settings.');
      }
    } catch (error) {
      console.error('Error saving miscellaneous settings:', error);
      Toast.error('An error occurred while saving miscellaneous settings.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} noValidate>
      <div className="space-y-6 mt-6">
        {isLoading ? (
          <SectionCard title="Additional Settings" icon={<AdditionalSettingsIcon />}>
            <div className="space-y-4">
              <div className="h-16 bg-gray-200 rounded animate-pulse"></div>
              <div className="h-16 bg-gray-200 rounded animate-pulse"></div>
            </div>
          </SectionCard>
        ) : (
          <SectionCard title="Additional Settings" icon={<AdditionalSettingsIcon />}>
            <div className="space-y-6">
              <ToggleField
                label="Exclude Legal Pages from Search Results"
                description="Hide legal pages from WordPress search"
                name="hide_lp_in_search"
                checked={formData.hide_lp_in_search}
                onChange={(name, value) =>
                  setFormData((prev) => ({ ...prev, [name]: value }))
                }
              />

              {/* <div className="bg-[#FEF2F2] border border-[#EF434333] rounded-xl p-4">
                <ToggleField
                  label="Remove Plugin Data on Uninstall"
                  description="Warning: This will delete all plugin data permanently"
                  name="delete_adl_lp_data"
                  checked={formData.delete_adl_lp_data}
                  onChange={(name, value) =>
                    setFormData((prev) => ({ ...prev, [name]: value }))
                  }
                />
              </div> */}
              <div className="bg-[#FEF2F2] border border-[#EF434333] rounded-xl p-4">
                <ToggleField
                  label="Remove Plugin Data on Uninstall"
                  description="Warning: This will delete all plugin data permanently"
                  name="delete_adl_lp_data"
                  checked={formData.delete_adl_lp_data}
                  variant="danger"
                  icon={<DangerIcon />}
                  onChange={(name, value) =>
                    setFormData((prev) => ({ ...prev, [name]: value }))
                  }
                />
              </div>
            </div>
          </SectionCard>
        )}

        <div className="flex items-center justify-start gap-2 rounded-xl p-4">
          <button
            type="submit"
            disabled={saving}
            className={[
              'inline-flex items-center cursor-pointer justify-center rounded-xl px-6 py-[14px] text-sm font-semibold text-white shadow-[0px_4px_14px_-2px_#7C3BED40] transition',
              saving ? 'cursor-not-allowed bg-indigo-400' : 'bg-[#7C3BED] hover:bg-indigo-700',
            ].join(' ')}
          >
            <img src={save} alt="Save Icon" className="mr-2 h-4 w-4" />
            {saving ? 'Saving...' : 'Save Settings'}
          </button>
        </div>
      </div>
    </form>
  );
};

export default Miscellaneous;